import { render, staticRenderFns } from "./Wholesale.vue?vue&type=template&id=ace3e154&scoped=true&"
import script from "./Wholesale.vue?vue&type=script&lang=js&"
export * from "./Wholesale.vue?vue&type=script&lang=js&"
import style0 from "./Wholesale.vue?vue&type=style&index=0&id=ace3e154&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace3e154",
  null
  
)

export default component.exports